module.exports = __webpack_public_path__ + "img/digital_1.1a517dcc.png";